export const useProductAttributes = () => {
  const getAttributeValue = (attribute: { attributeValue: string; unit: string }) => {
    return attribute.unit ? `${attribute.attributeValue} ${attribute.unit}` : attribute.attributeValue.toString();
  };
  return {
    getAttributeValue,
  };
};
